import { useEffect, useState, useContext } from 'react';
import classNames from 'classnames';
import { SingleOption } from './SingleOption';
import { canvasOptionsContext } from '../../../context/canvasOptionsContext';
import { canvasBackgroundContext } from '../../../context/canvasBackgroundContext';
import { canvasTextureContext } from '../../../context/canvasTextureContext';
import { OptionNames, CategoryNames } from '../../../types/namesList';
import styles from './options.module.css';
import { TextureSelect } from '../../../TextureSelect';
import { useBackgroundData } from '../../../hooks/useBackgroundData';
import { Title } from '../../../components/Title/Title';
import { Box, Grid } from '@mui/material';
import { useTextureData } from '../../../hooks/useTextureData';
import { useOptionsData } from '../../../hooks/useOptionsData';
// import { canvasModeContext } from "../../../context/canvasModeContext";
import { useCollectionsData } from "../../../hooks/useCollectionsData";
import { collectionsContext } from "../../../context/collectionsContext";
import { BaseContainer } from "../../BaseContainer/BaseContainer";

interface IOptionsProps {
    mode: string;
    setting?: number[];
}

export function Options({ mode, setting = [] }: IOptionsProps) {
    const { options, setOptions } = useContext(canvasOptionsContext);
    const { backgroundData } = useContext(canvasBackgroundContext);
    const [excludedOptions, setExcludedOptions] = useState<number[]>([]);
    const [installPrice, setInstallPrice] = useState(0);
    const [examplePrice, setExamplePrice] = useState(0);
    const [exampleExtraPrice, setExampleExtraPrice] = useState(0);
    // Данные текстур >>
    const [defaultCategoryIndex, setDefaultCategoryIndex] = useState<number>(0);
    const [defaultCollectionIndex, setDefaultCollectionIndex] = useState<number>(0);
    const url = new URL(window.location.href);
    const defaultCategory = url.searchParams.get('category') ?? '';
    const defaultName = url.searchParams.get('name') ?? '';
    // const { setImgData } = useContext(canvasTextureContext);
    // const { setOptions } = useContext(canvasOptionsContext);
    const { collectionsData } = useContext(collectionsContext);
    const [initialImgData] = useTextureData(collectionsData.elementId);
    const [initialBackgroundData] = useBackgroundData(collectionsData.elementId, collectionsData.sectionId);
    const [initialOptionsData] = useOptionsData(collectionsData.elementId, collectionsData.sectionId);
    const [newBackgroundData, setNewBackgroundData] = useState(initialBackgroundData);
    const [initialCollectionsData] = useCollectionsData();
    // const { isSeamless } = useContext(canvasModeContext);

    // console.log(options)

    useEffect(() => {

        if(options) {
            if(backgroundData.isSeamlessMode) {
                options.items.find(item => item.name === OptionNames.StandartSizes)!.isSet = true;
                options.items.find(item => item.name === OptionNames.NotStandartSizes)!.isSet = false;
            }

            setOptions({
                items: options.items,
            });
        }
    }, [backgroundData.isSeamlessMode]);

    useEffect(() => {
        // setImgData(initialImgData);
        // //
        // if(options) {
        //
        //     setOptions(options);
        // }

        setNewBackgroundData({
            ...initialBackgroundData,
            items: initialBackgroundData.items,
        });

        // Дефолтно выбранные Категория и Коллекция
        for (let i = 0; i < Object.keys(initialImgData.fullData).length; i++) {
            if((Object.values(initialImgData.fullData)[i] as any).name === defaultCategory) {
                setDefaultCategoryIndex(i);

                for (let j = 0; j < Object.keys((Object.values(initialImgData.fullData)[i] as any).collection).length; j++) {
                    if((Object.values((Object.values(initialImgData.fullData)[i] as any).collection)[j] as any).name === defaultName) {
                        setDefaultCollectionIndex(j);
                    }
                }
            }
        }
    }, [initialImgData, initialBackgroundData, initialOptionsData, initialCollectionsData]);
    // << Данные текстур


    useEffect(() => {
        const currentBackgroundData = backgroundData.items.find(item => item.groupName === backgroundData.groupName);

        // if(currentBackgroundData && currentBackgroundData.installPrice && currentBackgroundData.examplePrice && currentBackgroundData.exampleExtraPrice) {
        if(currentBackgroundData && currentBackgroundData.installPrice && currentBackgroundData.examplePrice || currentBackgroundData?.exampleExtraPrice) {
            setInstallPrice(currentBackgroundData!.installPrice);

            setExamplePrice(currentBackgroundData!.examplePrice);
            setExampleExtraPrice(currentBackgroundData!.exampleExtraPrice);
        }


        backgroundData.items.forEach(item => {

            if(item.groupName === backgroundData.groupName && item.excludedOptions) {
                const excludedArr: number[] = item.excludedOptions.map((option: string) => +option);
                setExcludedOptions(_state => excludedArr);
            } else if(item.groupName === backgroundData.groupName) setExcludedOptions(_state => []);
        });

    }, [backgroundData]);

    return (
        <Grid display="grid" gap="30px">
            {!setting.length && (
                <div>
                    <TextureSelect
                        defaultBackgroundData={initialBackgroundData}
                        defaultCategoryIndex={defaultCategoryIndex}
                        defaultCollectionIndex={defaultCollectionIndex}
                    />
                    <BaseContainer/>
                </div>
            )}

            <Grid display="grid">
                {!setting.length && <Title>Дополнительные опции</Title>}
                <Box className={classNames(styles.optionsContainer)}>
                    {options &&
                        options.items &&
                        options.items.map((option, key) => {

                            if(setting.length
                                ? !setting.includes(option.id)
                                : option.id === 1107
                                || option.id === 1108
                                || option.isHidden
                                || excludedOptions.includes(option.id)) return;


                            const minPriceText = option.minPrice
                                ? `Минимальная стоимость - ${option.minPrice} р.`
                                : '';

                            switch (option.name) {
                                case OptionNames.Install:
                                    option.price = installPrice;
                                    // option.minPrice = installMinPrice;
                                    break;
                                case OptionNames.Example:
                                    option.price = examplePrice;
                                    option.priceExtra = exampleExtraPrice;
                                    break;

                                case OptionNames.Seamless:
                                    if(backgroundData.isSeamlessMode) option.isSet = true;
                                    break;

                                // case OptionNames.StandartSizes:
                                //     // if(excludedOptions.includes(1108)) option.isSet = true;//
                                //     if(backgroundData.isSeamlessMode) option.isSet = true;
                                //
                                //     break;
                                // case OptionNames.NotStandartSizes:
                                //     // if(excludedOptions.includes(1520)) {
                                //     //     option.isSet = true;
                                //     // }
                                //     if(backgroundData.isSeamlessMode) option.isSet = false;
                                //     break;
                                default:
                                    break;
                            }

                            return (
                                <div key={key}
                                    // className={classNames(excludedOptions.includes(option.id) && styles.singleOptionDisabled)}
                                >

                                    <SingleOption
                                        name={option.name}
                                        price={option.price}
                                        priceExtra={option.priceExtra}
                                        checked={option.isSet}
                                        indexKey={key}
                                        isPricePerMeter={option.isPricePerMeter}
                                        isIndividualPrice={option.isIndividualPrice}
                                        isPercentToFullPrice={option.isPercentToFullPrice}
                                        dataText={option.dataText}
                                        excluded={excludedOptions.includes(option.id)
                                            || (option.name === OptionNames.Seamless && backgroundData.isSeamlessMode)}
                                        // hidden={setting.length
                                        //     ? !setting.includes(option.id)
                                        //     : option.id === 1107
                                        //     || option.id === 1108
                                        //     || option.isHidden}
                                        minPrice={option.minPrice}
                                        minPriceText={minPriceText}
                                        isExtraPrice={option.isExtraPrice}
                                        // noMargin={setting.includes(option.id)}
                                    />
                                </div>
                            );
                        })}
                </Box>
            </Grid>
        </Grid>
    );
}
